//src/services/adminDashboard.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminDashboardStats = (params = {}) => {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
  );

  const query = new URLSearchParams(clean).toString();
  const qs = query ? `?${query}` : "";

  return adminApiRequest(`/admin/dashboard/stats${qs}`);
};

export const getAdminDashboardHistory = (params = {}) => {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
  );

  const query = new URLSearchParams(clean).toString();
  const qs = query ? `?${query}` : "";

  return adminApiRequest(`/admin/dashboard/history${qs}`);
};